import { render, staticRenderFns } from "./introducePageTwo.vue?vue&type=template&id=56dfa21a&scoped=true"
import script from "./introducePageTwo.vue?vue&type=script&lang=js"
export * from "./introducePageTwo.vue?vue&type=script&lang=js"
import style0 from "./introducePageTwo.vue?vue&type=style&index=0&id=56dfa21a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56dfa21a",
  null
  
)

export default component.exports